<template>
    <span v-if="mostrarBtnCertidoes">
        <b-button variant="primary" @click.stop="obterCertidoes()">
            <span> <i class="fa fa-file-text-o"></i> Certidões</span>
        </b-button>
        <b-modal v-model="mostrarModal" :cancel-disabled="true">
            <div slot="modal-title">Certidões</div>
            <b-row>
                <b-col sm="12">
                    <b-alert show>
                        <strong>CND - Certidão Conjunta de Débitos PJ</strong>
                    </b-alert>
                    <cnd :fornecedor="fornecedor"></cnd>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-alert show>
                        <strong>FGTS - Regularidade do Empregador</strong>
                    </b-alert>
                    <fgts :fornecedor="fornecedor"></fgts>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="primary" @click.stop="fecharModal()"
                    >Ok</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import Cnd from '../../../certidoes/Cnd'
import Fgts from '../../../certidoes/Fgts'

export default {
    components: {
        Cnd,
        Fgts
    },

    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            fornecedor: {}
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        obterCertidoes() {
            this.$store.dispatch('addRequest')
            this.servicos
                .obterCertidoes(this.pagamento.pagamentoId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.fornecedor = response.data
                            this.mostrarModal = true
                        } else {
                            this.$toast.error(
                                'Erro ao obter certidões',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnCertidoes() {
            return this.$temAcesso('CONT-PAG-08')
        }
    }
}
</script>
